module.exports = __webpack_public_path__ + "static/media/01 REGGIANA CALCIO Mirabello.94efcfc0.svg";